import Link from "@/components/link/Link";
import { SEO_TRACK, SEO_URL } from "@/constants/horseRacing";

const contendersLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.CHURCHILL_DOWNS].CONTENDERS}>
    Kentucky Derby Contenders
  </Link>
);

const oddsLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.CHURCHILL_DOWNS].ODDS}>
    Kentucky Derby Odds
  </Link>
);

const bettingLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.CHURCHILL_DOWNS].BETTING}>
    Kentucky Derby Betting
  </Link>
);

const KentuckyDerbySeo = () => (
  <div>
    The 151st Run for the Roses takes place on Saturday, May 3rd, and savvy
    bettors are tracking every move. Explore the top {contendersLink}, analyze
    shifting {oddsLink}, and get expert {bettingLink} ahead of race day at
    Churchill Downs.
  </div>
);

export default KentuckyDerbySeo;
